import type { IContentType } from '~/@api/generated-api-types-user/Api'
import { HtmlContent } from '~/@mid_ui/html-content/HtmlContent'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '~/shadcn/ui/dialog'

type Props = {
  contentId: IContentType
  title?: string
  onClose(): void
}

function ContentDialog({ contentId, title, onClose }: Props) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="font-semibold">
        <DialogDescription title={title} />
        <DialogHeader className="h-[1.5rem]">
          {title && <DialogTitle title={title}>{title}</DialogTitle>}
        </DialogHeader>

        <HtmlContent typeId={contentId} lang={'sk'} />
      </DialogContent>
    </Dialog>
  )
}

export { ContentDialog }
